// extracted by mini-css-extract-plugin
export default {"imgContainer":"InteractionIcon_imgContainer__Y0HMJ","count":"InteractionIcon_count__A2Sjv","tooltiptext":"InteractionIcon_tooltiptext__QzQui"};